module.exports={
	"laptop": 1280,
	"tablet": 1024,
	"tabletPortrait": 880,
	"mobile": 720,
	"mobilePortrait": 480,
	"mobileSmall": 380
}